module.exports = __webpack_public_path__ + "static/BingeSpree-40957f5f3969b77a5622c86c063dc924.png";